// extracted by mini-css-extract-plugin
export default {"item":"FaqItem_item__Rme45","question":"FaqItem_question__iu1Dj","marker":"FaqItem_marker__N8u5g","answer":"FaqItem_answer__3bZ4q"};